export * from './types'
import { ExperimentConfig, Original } from './types'

export const LoanOffersGroupedBySubType: ExperimentConfig = {
  fallbackToOriginalOnDisabled: true,
  fallbackToOriginalOnError: true,
  name: 'EX-13.OfferSubtypeGrouping',
  variants: {
    Grouped: 'Grouped',
    Original,
  },
}

export const AdditionalQuestionsLowerCreditStep: ExperimentConfig = {
  fallbackToOriginalOnDisabled: true,
  fallbackToOriginalOnError: true,
  name: 'EX-10.AdditionalQuestionsForPoorAndFairLeads',
  variants: {
    BankRoutingNumber: 'BankRoutingNumber',
    DirectDeposit: 'DirectDeposit',
    Original,
    TotalUnsecuredDebt: 'TotalUnsecuredDebt',
  },
}

const PARTNER_UUID = {
  BUSINESS_INSIDER: '1829c16a-1a96-4f68-8dcb-17bb435f79d2', // Business Insider - RevShare - Embed - Loans
  CNBC: '64089c72-46f7-4e4a-b668-8b15043ddac5',
  CREDIT_SESAME: '345ce360-269f-4b3d-8bf3-e79e8053ff40', // Credit Sesame - REv Share - Partner Page - Loans - Email
  EARNEST: 'd45654a3-88cc-4591-8344-19a347bdc815', // Earnest - Rev Share - Embed - Loans
  EAST_BRIDGE: '429ec10a-6514-4ca0-8571-18c00c76e745', // East Bridge - REv Share - Embed - Personal Loans
  FIG_LOANS: '06ca3349-d461-41c7-9b60-c8d697176ce7', // Fig Loans Turnups - RevShare - PP - Loans
  FIONA: '5eeab848-2ab7-43b0-aa78-879868f0a327', // Fiona
  FIONA_SEM: '97678c82-c45c-4882-a051-d2931c6f0c48', // Fiona - SEM
  INVESTOPEDIA: '974cf958-10df-4867-bb82-af5a9d2e62ae', // Investopedia - Rev Share - PP - Loans
  INVESTOPEDIA_CUSTOM: '25fc330c-a740-4978-9f2e-eb1705000029', // Investopedia - Rev Share - Custom Embed - Loans
  MONEYLION: '58fc7e35-4249-4ad7-98ed-e354e2ed7375', // MoneyLion - Rev Share - PP - Loans
  NEW_DAY_ANALYTICS: '6161c955-e1e7-4a9e-b153-003ff9ca9bbb', // New Day Analytics - RTP - Embed - Loans
  OPP_LOANS: '3da06bdb-6a77-4846-a1ec-2c9a70c5315e', // OppLoans - Declines - RevShare - PP - Loans
  SWIPE_SOLUTIONS: 'efab46a6-773c-4ff5-b824-28f3b14d2d03', // Swipe Solutions - Embed - Loans
  THE_BALANCE: '37b09749-6b8c-41cc-960c-2d685a8b3709', // The Balance - Revshare - PP - Loans
  TRANSUNION: 'ee6f467f-d437-4834-9430-83a5b411858f', // TransUnion - Email & DFP - PP - Loans
}

const FIONA_COHORT = [PARTNER_UUID.FIONA, PARTNER_UUID.FIONA_SEM]

export const OfferGroupingCohort = FIONA_COHORT

export const AdditionalQuestionsCohort = [
  ...FIONA_COHORT,
  PARTNER_UUID.MONEYLION,
  PARTNER_UUID.INVESTOPEDIA,
  PARTNER_UUID.TRANSUNION,
  PARTNER_UUID.EARNEST,
  PARTNER_UUID.FIG_LOANS,
  PARTNER_UUID.OPP_LOANS,
  PARTNER_UUID.THE_BALANCE,
]

export const AdditionalQuestionsLowerCreditCohort = [
  PARTNER_UUID.MONEYLION,
  PARTNER_UUID.INVESTOPEDIA,
  PARTNER_UUID.TRANSUNION,
  PARTNER_UUID.EARNEST,
  PARTNER_UUID.FIG_LOANS,
  PARTNER_UUID.OPP_LOANS,
  PARTNER_UUID.THE_BALANCE,
]

export const AdditionalQuestionsLowerCreditStepCohort = AdditionalQuestionsLowerCreditCohort

export interface ExperimentCohorts {
  [FeatureName: string]: string[]
}

// TEMPORARY DO NOT ADD ANYTHING HERE
export const ExperimentCohortMap: ExperimentCohorts = {
  [LoanOffersGroupedBySubType.name]: OfferGroupingCohort,
  [AdditionalQuestionsLowerCreditStep.name]: AdditionalQuestionsLowerCreditStepCohort,
}
